import { render, staticRenderFns } from "./CreateShop.vue?vue&type=template&id=343603c5&scoped=true&"
import script from "./CreateShop.vue?vue&type=script&lang=js&"
export * from "./CreateShop.vue?vue&type=script&lang=js&"
import style0 from "./CreateShop.vue?vue&type=style&index=0&id=343603c5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343603c5",
  null
  
)

export default component.exports